import { render, staticRenderFns } from "./offer-supplier-requirements-view.vue?vue&type=template&id=64f19a11&"
import script from "./offer-supplier-requirements-view.vue?vue&type=script&lang=js&"
export * from "./offer-supplier-requirements-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f19a11')) {
      api.createRecord('64f19a11', component.options)
    } else {
      api.reload('64f19a11', component.options)
    }
    module.hot.accept("./offer-supplier-requirements-view.vue?vue&type=template&id=64f19a11&", function () {
      api.rerender('64f19a11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44/partials/offer-supplier-requirements-view.vue"
export default component.exports